import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import "babel-polyfill";

import Vant from "vant";
import "vant/lib/index.css";
import "lib-flexible";
import store from "../store";
import Vconsole from "vconsole";
import VueCropper from "vue-cropper";
import "../assets/icons"; // icon

import { Toast } from "vant";

if (location.href.indexOf("debug=true") > 0) {
  let vConsole = new Vconsole();
}

Vue.use(VueCropper);
Vue.config.productionTip = false;
Vue.use(Vant);


new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
